import { useCallback } from 'react';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { CREDIT_MEMO_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export const useGetMessageBusUpdates = creditMemoObjectId => {
  const sendObjectsUpdatedMessage = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_OBJECTS);
  const sendAssociationsUpdatedMessage = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_ASSOCIATIONS);
  const sendObjectsDeletedMessage = useSendCrmMessageTopic(TOPIC_NAMES.OBJECTS_DELETED);

  // Broadcasts Credit Memo Updated Message to update the index page
  const sendCreditMemoUpdatedMessage = useCallback(() => {
    if (creditMemoObjectId) {
      return sendObjectsUpdatedMessage([{
        objectTypeId: CREDIT_MEMO_TYPE_ID,
        objectId: String(creditMemoObjectId)
      }]);
    }
  }, [creditMemoObjectId, sendObjectsUpdatedMessage]);

  // Broadcasts Credit Memo Deleted Message to update sidebar
  const sendCreditMemoDeletedMessage = useCallback(() => {
    if (creditMemoObjectId) {
      return sendObjectsDeletedMessage([{
        objectTypeId: CREDIT_MEMO_TYPE_ID,
        objectId: String(creditMemoObjectId)
      }]);
    }
  }, [creditMemoObjectId, sendObjectsDeletedMessage]);

  // Broadcasts Credit Memo Updated Message to update associated
  // objects sidebar cards (e.g. Company, Line Item, Contact)
  const updateCreditMemoAssociations = useCallback(toObjectTypeId => {
    if (creditMemoObjectId) {
      return sendAssociationsUpdatedMessage({
        objectTypeId: CREDIT_MEMO_TYPE_ID,
        toObjectTypeId,
        objectId: String(creditMemoObjectId)
      });
    }
  }, [creditMemoObjectId, sendAssociationsUpdatedMessage]);
  return {
    sendCreditMemoUpdatedMessage,
    sendCreditMemoDeletedMessage,
    updateCreditMemoAssociations
  };
};